module.exports = __webpack_public_path__ + "static/media/Pooping.849daefa.png";